import { useAsyncExecutor } from "async-executor-hook";
import { useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { of } from "rxjs";

import { useAuthorization } from "./common/AuthorizationCpt";
import AdminDocumentManagement from "./components/AdminDocumentManagement/AdminDocumentManagement";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ImportFlow from "./components/ImportFlow/ImportFlow";
import Login from "./components/Login/Login";
import {
  LoadingScreen,
  LoginScreen,
  LoginFooter,
} from "./components/Login/LoginStyles";
import LoadingGray from "./images/loading_gray.gif";
import LoginBackground from "./images/login_background.png";
import { getSession } from "./utils/authUtils";
import { HTTP_METHODS } from "./utils/constants";
import { networkBackendRequest } from "./utils/networkUtils";
import { ADMIN_ROUTES, USER_ROUTES } from "./utils/routeConstants";
function AppRoutes() {
  const history = useHistory();
  const authorization = useAuthorization();
  const historyPushAgent = (typeUser) => {
    switch (typeUser) {
      case "Tesorero":
        history.push(USER_ROUTES.PAYMENT.path);
        break;
      case "Cotizador":
        history.push(USER_ROUTES.ORDERS.path);
        break;
      case "Agente Despachador Aduanero":
        history.push(USER_ROUTES.ORDERS.path);
        break;
      case "Facturador":
        history.push(USER_ROUTES.ORDERS.path);
        break;
      case "Despachador":
        history.push(USER_ROUTES.DATES.path);
        break;
      case "Administrador":
        history.push(USER_ROUTES.USER_AGENT.path);
        break;

      default:
        history.push(USER_ROUTES.COMPLAINTS.path);
        break;
    }
  };
  const historyPushBackoffice = (typeUser) => {
    switch (typeUser) {
      case "Facturador":
        history.push(ADMIN_ROUTES.DOCUMENT_VALIDATION.path);
        break;
      case "Despachador":
        history.push(ADMIN_ROUTES.TURN_CONFIRMATION.path);
        break;
      case "customer_support":
        history.push(ADMIN_ROUTES.COMPLAINTS.path);
        break;
      case "Administrador":
        history.push(ADMIN_ROUTES.ADMIN_USERS.path);
        break;
      default:
        history.push(ADMIN_ROUTES.COMPLAINTS.path);
        break;
    }
  };
  const obtainSession = useAsyncExecutor(
    async () => {
      const session = await getSession();
      const user = await networkBackendRequest("/login/me/", HTTP_METHODS.GET, {
        fields: "category",
      }).then((response) => response.json());
      return { ...user, session };
    },
    {
      source$: of({}),
      onSuccess: (user) => {
        authorization.setPermision(user.profile.permissions);
        const token = user.session.accessToken.jwtToken;
        localStorage.setItem("accessToken", token);
        const location = history.location;
        if (
          location.pathname === "/" ||
          location.pathname.includes("/guest/")
        ) {
          if (user.profile.role.module === "backoffice") {
            historyPushBackoffice(user.profile.name);
          } else {
            historyPushAgent(user.profile.name);
          }
        }
      },
      onError: () => {
        history.push("/guest/login");
      },
    }
  );

  const closeSession = () => {
    localStorage.removeItem("accessToken");
    window.location.href = "/";
  };

  const emailState = useState("");

  return (
    <div>
      {obtainSession.isLoading && (
        <LoadingScreen>
          <img src={LoadingGray} width="50" height="50" alt="Loading screen" />
          <p>Cargando...</p>
        </LoadingScreen>
      )}
      {obtainSession.isSuccess && (
        <Route path="/web">
          <Route path="/web/admin">
            {obtainSession.data.profile.role.module === "backoffice" ? (
              <AdminDocumentManagement
                userInfo={obtainSession.data}
                updateLogged={closeSession}
              />
            ) : (
              <h1>No tiene permiso para ver esta pagina</h1>
            )}
          </Route>
          <Route path="/web/importaciones">
            {obtainSession.data.profile.role.module === "intranet" ? (
              <ImportFlow
                userInfo={obtainSession.data}
                updateLogged={closeSession}
              />
            ) : (
              <h1>No tiene permiso para ver esta pagina</h1>
            )}
          </Route>
        </Route>
      )}
      {obtainSession.isError && (
        <Route path="/guest">
          <LoginScreen img={LoginBackground}>
            <Route path="/guest/login">
              <Login emailState={emailState} />
            </Route>
            <Route path="/guest/forgot-password">
              <ForgotPassword email={emailState[0]}></ForgotPassword>
            </Route>
            <LoginFooter>
              TALMA SERVICIOS AEROPORTUARIOS S.A. - RUC: 20204621242
            </LoginFooter>
          </LoginScreen>
        </Route>
      )}
    </div>
  );
}

export default AppRoutes;
